(function () {
  'use strict';
  var w = window, d = document, root = d.documentElement;
  var off = !('IntersectionObserver' in w) ||
    w.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (w.Shopify && w.Shopify.designMode);
  root.setAttribute('data-sk-ready', '1');
  if (off) { root.classList.remove('sk-js'); return; }

  var raf = w.requestAnimationFrame.bind(w);
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  function count(el) {
    var m = (el.textContent || '').match(/^(\D*)(\d+)(.*)$/);
    if (!m) return;
    var pre = m[1], end = +m[2], suf = m[3], t0 = null;
    el.textContent = pre + '0' + suf;
    (function step(t) {
      if (!t0) t0 = t;
      var k = clamp((t - t0) / 1300, 0, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = pre + Math.round(end * e) + suf;
      if (k < 1) raf(step);
    })(performance.now());
  }

  function setAll(list, val) {
    for (var i = 0; i < list.length; i++) list[i].style.setProperty('--p', val);
  }

  function init() {
    var sel = ['.sk-tiles>.sk-tile', '.sk-packs>.sk-pack', '.sk-stats>.sk-stat', '.sk-strip__item',
      '.sk-faq details', '.sk-head', '.sk-text', '.sk-band h2', '.sk-band p', '.sk-hero__copy>*', "[id*='__pl_']"];
    var els = [];
    sel.forEach(function (s) {
      [].forEach.call(d.querySelectorAll(s), function (el, i) {
        el.style.setProperty('--d', (i % 6) * 0.09 + 's');
        els.push(el);
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        io.unobserve(el);
        if (el.classList.contains('sk-stat')) count(el.querySelector('b'));
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });

    var h1 = d.querySelector('.sk-hero__copy h1');
    if (h1 && !h1.querySelector('.w')) {
      var words = h1.textContent.trim().split(/\s+/);
      h1.setAttribute('aria-label', h1.textContent.trim());
      h1.textContent = '';
      words.forEach(function (t, i) {
        var o = d.createElement('span'), n = d.createElement('span');
        o.className = 'w'; o.setAttribute('aria-hidden', 'true');
        n.style.setProperty('--i', i); n.textContent = t;
        o.appendChild(n); h1.appendChild(o);
        if (i < words.length - 1) h1.appendChild(d.createTextNode(' '));
      });
    }

    var hero = d.querySelector('.sk-hero');
    var heroMoving = hero ? [].slice.call(hero.querySelectorAll('.sk-hero__art>img, .sk-flat .sk-sock')) : [];
    var tileSocks = [].slice.call(d.querySelectorAll('.sk-tile')).map(function (t) {
      return { tile: t, sock: t.querySelector('.sk-sock') };
    });
    var band = d.querySelector('.sk-band');
    var bandWalkers = band ? [].slice.call(band.querySelectorAll('.sk-walker')) : [];
    var bar = d.createElement('div');
    bar.id = 'sk-progress';
    d.body.appendChild(bar);

    function prog(el, r) {
      var vh = w.innerHeight;
      return clamp(((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2), -1, 1);
    }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = w.innerHeight, max = root.scrollHeight - vh;
      bar.style.setProperty('--sp', max > 0 ? clamp(w.scrollY / max, 0, 1) : 0);
      if (hero && heroMoving.length) {
        var hr = hero.getBoundingClientRect();
        setAll(heroMoving, clamp(-hr.top / hr.height, 0, 1));
      }
      tileSocks.forEach(function (o) {
        var r = o.tile.getBoundingClientRect();
        if (o.sock && r.bottom > -120 && r.top < vh + 120) o.sock.style.setProperty('--p', prog(o.tile, r));
      });
      if (band && bandWalkers.length) {
        var br = band.getBoundingClientRect();
        if (br.bottom > -120 && br.top < vh + 120) setAll(bandWalkers, prog(band, br));
      }
    }
    function onScroll() { if (!ticking) { ticking = true; raf(update); } }
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll);
    update();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
